import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { createTextFileApi, mappingdata, RoleandMapping, shariahconfig, getshariahconfig, OwnershipApi, ListAlldept, Getlocations, residualListApi, residualSaveApi } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { BiSortUp, BiSortDown, BiSort } from "react-icons/bi";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { tableCellStyle2, UsersPagination } from "../components/TableProperty";
import { Modal, Button } from 'react-bootstrap';
import { SearchBox, UploadLoadingIcon } from "../components/Propertyfile";
import GapsyShariahModify from './gapsyShariahModify';

const GapsyShariahConfiguration = () => {
    const [activeTab, setActiveTab] = useState('ldap'); // 'manual' or 'ai'
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const usersItemsPerPage = 7; // Set the number of items per page
    const navigate = useNavigate();
    const [userPerPage, setUsersPerPage] = useState(1); // Set the initial page to 1
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [modalMessage3, setModalMessage3] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry

    const [selectedOption, setSelectedOption] = useState('All');
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [mode, setMode] = useState("");
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [formData, setFormData] = useState({
        adminId: '',
        userId: '',
        userName: '',
        userRole: '',
        departments: '',
        departmentname: '',
        userRole: '',
        orgHierarchy: '',
        userLocation: '',
        active_yn: '',
        mappedId: '',
        searchUserId: '' // Add this line
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChecker, setSelectedChecker] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [selectedWorkflow, setSelectedWorkflow] = useState("");
    const [workflowRoles, setWorkflowRoles] = useState("");
    const [editData, setEditData] = useState(null);

    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const dept = sessionStorage.getItem("dept");

    useEffect(() => {
        fetchUsers();
    }, []);

    const WORKFLOW_TEMPLATES = {
        "Shariah Risk": {
            label: "Shariah Risk",
            apiName: "Shariah Risk",
        },
        "Residual Operational Risk": {
            label: "Residual Operational Risk",
            apiName: "Residual Operational Risk",
        },
        "Customer Complaints": {
            label: "Customer Complaints",
            apiName: "Customer Complaints",
        },
        "Media Publicity": {
            label: "Media Publicity",
            apiName: "Media Publicity",
        },
        "Operational Thresholds": {
            label: "Operational Thresholds",
            apiName: "Operational Thresholds",
        },
        "Leadership Thresholds": {
            label: "Leadership Thresholds",
            apiName: "Leadership Thresholds",
        },
        "Compliance": {
            label: "Compliance",
            apiName: "Compliance",
        },
    };

    const getWorkflowTemplate = (template) => {
        const value = String(template ?? "").trim();

        if (WORKFLOW_TEMPLATES[value]) {
            return WORKFLOW_TEMPLATES[value];
        }

        // Handle the backend returning the API identifier.
        if (value === "Risk_customer_complaints") {
            return WORKFLOW_TEMPLATES["Customer Complaints"];
        }

        if (value === "Risk_media_publicity") {
            return WORKFLOW_TEMPLATES["Media Publicity"];
        }
        if (value === "Risk_operational_thresholds") {
            return WORKFLOW_TEMPLATES["Operational Thresholds"];
        }
        if (value === "Risk_leadership_thresholds") {
            return WORKFLOW_TEMPLATES["Leadership Thresholds"];
        }
        if (value === "Risk_compliance") {
            return WORKFLOW_TEMPLATES["Compliance"];
        }

        // Handle dynamically created templates
        const excelTitle = localStorage.getItem("excelTitle")?.trim();

        if (excelTitle && value === excelTitle) {
            return {
                label: excelTitle,
                apiName: excelTitle,
            };
        }

        return {
            label: value,
            apiName: value,
        };
    };

    const fetchUsers = async () => {
        try {
            setIsLoading(true);

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    templateName: "All",
                },
            };

            const response = await axios.post(
                residualListApi,
                {},
                config
            );

            console.log("API Response:", response.data);

            const permissions = response.data?.permissions || [];

            const apiData = permissions.map((item) => {
                const templateInfo = getWorkflowTemplate(item.template);

                const workflowAction =
                    item.workflow_action ||
                    item.workflowAction ||
                    "";

                return {
                    ...item,
                    template: templateInfo.label,
                    apiTemplateName: templateInfo.apiName,
                    workflow: item.workflow || "",
                    active: item.Active ?? item.active ?? "",
                    workflowAction,
                    roles: workflowAction
                        .split(",")
                        .map((role) => role.trim())
                        .filter(Boolean),
                };
            });

            setUsers(apiData);
            setFilteredUsers(apiData);


        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchOwnership = async () => {
        try {
            // setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchOwnership();
    }, []);

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };

    const handleEdit = (data) => {
        console.log("Edit selected row:", data);

        setEditData(data);
        setMode("edit");

        const templateInfo = getWorkflowTemplate(
            data.apiTemplateName || data.template
        );

        setSelectedTemplate(templateInfo.label);
        setSelectedWorkflow(data.workflow || "");

        setWorkflowRoles(
            data.workflowAction ||
            data.workflow_action ||
            ""
        );
    };

    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            // setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };

    const submitLdapData = async (allowUpdate = "") => {
        try {
            const adminId = localStorage.getItem("userid") || "";

            const parentTemplate = "Residual Risk";

            const templateInfo = getWorkflowTemplate(selectedTemplate);
            const permissionTemplate = templateInfo.apiName;

            const workflow = selectedWorkflow || "";
            const workflowAction = workflowRoles || "";

            if (!permissionTemplate) {
                throw new Error("Template is required.");
            }

            if (!workflow) {
                throw new Error("Workflow is required.");
            }

            if (!workflowAction) {
                throw new Error("Workflow approval roles are required.");
            }

            const permission = {
                template: permissionTemplate,
                [workflow]: workflowAction,
                Active: "Y",
            };

            const jsonData = {
                template: parentTemplate,
                adminId,
                permissions: [permission],
            };

            const content = JSON.stringify(jsonData, null, 2);

            const safeTemplateName = permissionTemplate
                .replace(/[^a-zA-Z0-9_-]/g, "_");

            // const filename =
            //     `${adminId}_${safeTemplateName}_workflow.json`;

            const filename = `${adminId}_workflow.json`;

            console.log("Filename:", filename);
            console.log("Content:", content);

            // =============================================
            // STEP 1: CREATE TEXT FILE
            // =============================================
            const fileResponse = await axios.post(
                createTextFileApi,
                {
                    filename: filename,
                    content: content
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        userId: adminId,
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true
                }
            );

            console.log("Create Text File Response:", fileResponse.data);

            // =============================================
            // STEP 2: MAPPING / CONFIGURATION API
            // =============================================
            const config = {
                headers: {
                    adminId: adminId,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
                params: {
                    filePath: `/saswork/nas/${filename}`,
                    Notifications: "IN",

                    templateName: permissionTemplate,
                    workflow: workflow,
                    workflowAction: workflowAction,

                    dept: dept,
                    allowUpdate: allowUpdate
                }
            };

            console.log("Mapping API Config:", config);

            const response = await axios.post(
                residualSaveApi,
                {},
                config
            );

            console.log("Mapping API Response:", response.data);

            return response;

        } catch (error) {
            console.error("Error in submitLdapData:", error);
            throw error;
        }
    };

    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            // Template validation
            if (!selectedTemplate) {
                setMessageType("error");
                setModalMessage("Please select a template.");
                return;
            }

            setIsLoading(true);

            const responseDb = await submitLdapData();

            if (responseDb.data?.status?.toLowerCase() === "update") {
                setPendingPayload(true);

                setModalMessage3(`
                Configuration already exists.<br/>
                  Do you want to update?
              `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status?.toLowerCase() === "success") {
                setMessageType("success");
                setModalMessage("Workflow Configuration Modified Successfully");

                await fetchUsers();

            } else {
                setMessageType("error");
                setModalMessage(responseDb.data?.message || "Failed");
            }
        } catch (error) {
            console.error(error);
            setMessageType("error");
            setModalMessage("Error while processing request.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCloseModal = () => {
        setModalMessage('');
        setMessageType('');
    };

    const handleCloseLdap = () => {
        setModalMessage('');
        setModalMessage3('');
        setShowModalLdap(false);

        setInitialData({});
        setEditIndex(null);
        setMessage('');

        //  REFRESH TABLE
        fetchUsers();
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleAddRow = (e) => {
        e.preventDefault();
        navigate('/GapsyResidualConfig');
        // Additional logic if needed
    };

    const getSortedAndFilteredUsers = () => {
        if (!Array.isArray(filteredUsers)) return [];  //  safety

        return [...filteredUsers].sort((a, b) => {
            if (a.newlyCreated && !b.newlyCreated) return -1;
            if (!a.newlyCreated && b.newlyCreated) return 1;

            const aValue = typeof a[sortConfig.key] === 'string'
                ? a[sortConfig.key].toLowerCase()
                : a[sortConfig.key];

            const bValue = typeof b[sortConfig.key] === 'string'
                ? b[sortConfig.key].toLowerCase()
                : b[sortConfig.key];

            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;

            return 0;
        });
    };

    const sortedAndFilteredUsers = getSortedAndFilteredUsers();


    const handleReset = () => {

        if (!editData) {
            return;
        }

        setSelectedTemplate(editData.template || "");
        setSelectedWorkflow(editData.workflow || "");
        setWorkflowRoles(editData.workflowAction || "");

        console.log("Form reset to:", editData);
    };

    // const handleEdit = (data) => {

    //     console.log("Edit selected row:", data);

    //     setMode("edit");

    //     // Populate Template
    //     setSelectedTemplate(data.template || "");

    //     // Populate Workflow
    //     setSelectedWorkflow(data.workflow || "");

    //     // Populate Workflow Approval Roles
    //     setWorkflowRoles(data.workflowAction || "");

    //     console.log("Selected Template:", data.template);
    //     console.log("Selected Workflow:", data.workflow);
    //     console.log("Selected Workflow Roles:", data.workflowAction);
    // };

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <BiSort />;  // Neutral/no sort icon
        }
        return sortConfig.direction === 'ascending'
            ? <BiSortUp />
            : <BiSortDown />;
    };

    const availableRoles = [
        "Maker",
        "Checker",
        "Risk Officer",
        "Risk SuperUser"
    ];

    const rolesToDisplay = availableRoles.filter(role =>
        sortedAndFilteredUsers.some(user =>
            user.roles?.some(
                r => r.toLowerCase() === role.toLowerCase()
            )
        )
    );

    const renderUsersTable = () => {

        const startIndex = (userPerPage - 1) * usersItemsPerPage;

        return sortedAndFilteredUsers
            .slice(startIndex, startIndex + usersItemsPerPage)
            .map((data, index) => {

                return (
                    <tr key={index}>

                        {/* Edit */}
                        <td>
                            <i
                                className="bi bi-pencil"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(data)}
                            />
                        </td>

                        {/* Template */}
                        <td>
                            {data.template}
                        </td>

                        {/* Workflow Action */}
                        <td>
                            {data.roles && data.roles.length > 0 ? (
                                <div className="d-flex justify-content-center align-items-center flex-wrap gap-1">

                                    {data.roles.map((role, roleIndex) => (
                                        <React.Fragment key={roleIndex}>

                                            <span className="badge bg-primary">
                                                {role}
                                            </span>

                                            {roleIndex < data.roles.length - 1 && (
                                                <span className="fw-bold text-muted">
                                                    →
                                                </span>
                                            )}

                                        </React.Fragment>
                                    ))}

                                </div>
                            ) : (
                                "-"
                            )}
                        </td>
                    </tr>
                );
            });
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = users.filter(user => {
            const userId = user.userId?.toString().toLowerCase() || "";
            const userName = user.userName?.toLowerCase() || "";
            const userRole = user.userRole?.toLowerCase() || "";
            const department = user.departmentname?.toLowerCase() || "";

            return (
                userId.includes(query) ||
                userName.includes(query) ||
                userRole.includes(query) ||
                department.includes(query)   // IMPORTANT FIX
            );
        });

        if (filtered.length === 0) {
            setShowNoRecordsModal(true);
            setSearchQuery('');
            setFilteredUsers(users);
        } else {
            setFilteredUsers(filtered);
        }

        setUsersPerPage(1);
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-diagram-3 me-2"></i>Workflow Configuration
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 mx-auto">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">

                                        {/* Header + Search Row with single underline */}
                                        <div className={`d-flex justify-content-between align-items-center pb-2 mb-2 ${styles.borderBottom}`}>

                                            {/* Left: Heading */}
                                            <h6 className="mb-0">Workflow Configuration</h6>

                                            {/* Right: Search Box */}
                                            <div className="d-flex flex-wrap gap-3">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={handleAddRow}
                                                    title="Add New Configuration"
                                                >
                                                    <i className="bi bi-plus" style={{ fontSize: '14px' }}></i>
                                                </button>
                                                <SearchBox searchTerm={searchQuery} handleSearch={handleSearch} />
                                            </div>
                                        </div>

                                        <div className="table-on-homepage-only mb-3">
                                            <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <thead>
                                                        <tr>
                                                            <th>Edit</th>
                                                            <th>Template</th>
                                                            <th>Workflow Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{renderUsersTable()}</tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* )} */}


                                        {/* Pagination */}
                                        <div className="d-flex justify-content-end">
                                            <UsersPagination
                                                currentPage={userPerPage}
                                                itemsPerPage={usersItemsPerPage}
                                                totalItems={sortedAndFilteredUsers.length}
                                                onPageChange={setUsersPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="">
                                            <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify Workflow Configuration</h6>
                                            <div className={`mx-auto ${formStyles.formWrapper}`}>
                                                {mode === "edit" ? (
                                                    <form className="form px-3" onSubmit={handleLdapSubmit}>

                                                        <input
                                                            type="hidden"
                                                            name="adminId"
                                                            value={localStorage.getItem("userid")}
                                                            readOnly
                                                        />
                                                        <div className="form-group row mb-3">
                                                            <label className="col-sm-4 col-form-label label-black">
                                                                Template
                                                                <span className="text-danger ms-1">*</span>
                                                            </label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm bg-light disabled"
                                                                    name="template"
                                                                    value={selectedTemplate}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-3">

                                                            <label className="col-sm-4 col-form-label label-black">
                                                                Workflow Approval Roles
                                                                <span className="text-danger ms-1">*</span>
                                                            </label>

                                                            <div className="col-sm-7">

                                                                <div className="border rounded p-3">

                                                                    <div className="mb-3">
                                                                        <small className="text-muted">
                                                                            Select one approval workflow for the selected template.
                                                                        </small>
                                                                    </div>

                                                                    {/* Workflow 1 */}
                                                                    <div className="form-check mb-3">

                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="workflowRoles"
                                                                            id="workflow1"
                                                                            value="Maker,Checker,Risk Officer,Risk SuperUser"
                                                                            checked={
                                                                                workflowRoles ===
                                                                                "Maker,Checker,Risk Officer,Risk SuperUser"
                                                                            }
                                                                            onChange={(e) => {
                                                                                setWorkflowRoles(e.target.value);
                                                                                setSelectedWorkflow("workflow-1");
                                                                            }}
                                                                        />

                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="workflow1"
                                                                        >
                                                                            Maker → Checker → Risk Officer → Risk SuperUser 
                                                                        </label>

                                                                    </div>

                                                                    {/* Workflow 2 */}
                                                                    <div className="form-check mb-2">

                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="workflowRoles"
                                                                            id="workflow2"
                                                                            value="Maker,Checker,Risk Officer"
                                                                            checked={
                                                                                workflowRoles ===
                                                                                "Maker,Checker,Risk Officer"
                                                                            }
                                                                            onChange={(e) => {
                                                                                setWorkflowRoles(e.target.value);
                                                                                setSelectedWorkflow("workflow-2");
                                                                            }}
                                                                        />

                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="workflow2"
                                                                        >
                                                                            Maker → Checker → Risk Officer
                                                                        </label>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        {/* Buttons */}
                                                        <div className="form-group row">
                                                            <div className="col-sm-4"></div>

                                                            <div className="col-sm-7 d-flex">
                                                                {/* <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm me-2"
                                                                    onClick={handleReset}
                                                                >
                                                                    Reset
                                                                </button> */}

                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary btn-sm"
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </form>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <p className="text-muted small">Select a template to modify</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {showAllowUploadPopup && (
                                <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                    <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                        <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                        /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                        dangerouslySetInnerHTML={{
                                            __html: modalMessage3.replace(/\n/g, '<br />')
                                        }}>
                                    </Modal.Body>
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                        <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                    </Modal.Footer>
                                </Modal>
                            )}

                            {/* Modal for messages */}
                            <Modal
                                show={!!modalMessage}
                                onHide={handleCloseModal}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: '12vh' }}
                            >
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                        >
                                            {modalMessage}
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseLdap}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyShariahConfiguration;
